import type { Project } from "@/types/projects";
import { responsive } from "@/lib/img";

export default function ProjectCover({
  project,
  priority = false,
  className = "",
}: {
  project: Project;
  priority?: boolean;
  className?: string;
}) {
  const cover = project.images?.[0];

  if (cover) {
    const { src, srcSet } = responsive(cover);

    return (
      <img
        src={src}
        srcSet={srcSet}
        sizes="(max-width: 768px) 100vw, 50vw"
        alt={project.title}
        width={2000}
        height={1000}
        fetchPriority={priority ? "high" : undefined}
        loading={priority ? "eager" : "lazy"}
        decoding="async"
        className={`w-full h-full object-cover select-none ${className}`}
        draggable={false}
      />
    );
  }

  return (
    <div
      className={`w-full h-full flex flex-col justify-between gap-6 p-6 md:p-8 bg-brand text-on-brand select-none ${className}`}
      role="img"
      aria-label={project.title}
    >
      <p className="font-mono text-[11px] tracking-[0.2em] uppercase opacity-70">
        {project.category[0]}
      </p>
      <p className="text-2xl md:text-4xl font-medium leading-tight text-balance">
        {project.title}
      </p>
    </div>
  );
}
